import service from '@/utils/request'

export const ossList = (params) => {
  return service({
    url: '/blade-resource/oss/list',
    method: 'GET',
    params,
  })
}

export const ossSubmit = (data) => {
  return service({
    url: '/blade-resource/oss/submit',
    method: 'POST',
    data,
  })
}

export const ossDelete = (query) => {
  return service({
    url: '/blade-resource/oss/remove',
    method: 'POST',
    params: query
  })
}

export const ossEnable = (data) => {
  return service({
    url: '/blade-resource/oss/enable',
    method: 'POST',
    params: data,
  })
}